// 账户
const account = () => import(/* webpackChunkName: 'accountIndex' */ '@views/account/index')
const login = () => import(/* webpackChunkName: 'accountLogin' */ '@views/account/login')
const register = () => import(/* webpackChunkName: 'accountRegister' */ '@views/account/register')
const retrievePassword = () =>
  import(/* webpackChunkName: 'accountRetrievePassword' */ '@views/account/retrievePassword')

const routes = [
  {
    path: '/account',
    component: account,
    meta: { title: '', first: false, resourceCode: '' },
    children: [
      {
        path: 'login',
        name: 'login',
        component: login
      },
      {
        name: 'register',
        path: 'register',
        component: register
      },
      {
        name: 'retrievePassword',
        path: 'retrievePassword',
        component: retrievePassword
      }
    ]
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/account/index.js